import { render, staticRenderFns } from "./VSystemActivityForm.vue?vue&type=template&id=5b65b88d&"
import script from "./VSystemActivityForm.vue?vue&type=script&lang=js&"
export * from "./VSystemActivityForm.vue?vue&type=script&lang=js&"
import style0 from "./VSystemActivityForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports